
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout-instructions/skype",
      function () {
        return require("private-next-pages/ai-optout-instructions/skype/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout-instructions/skype"])
      });
    }
  